import { createFileRoute, redirect } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { Skeleton } from "@/components/feedback/Skeleton";
import { StandingOrderCard } from "@/features/standingOrders/StandingOrderCard";
import { getStandingOrder, standingOrderKeys } from "@/features/standingOrders/standingOrders.api";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

// The card of a standing order, or a new one (id "new"): docs/tms-vaste-orders.md.
export const Route = createFileRoute("/_shell/standing-orders/$id")({
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "tms_orders") && !hasModule(context.session, "tms_orders_write")) {
      throw redirect({ to: firstAllowedRoute(context.session) });
    }
  },
  component: StandingOrderScreen,
});

function StandingOrderScreen() {
  const { id } = Route.useParams();
  const { session } = Route.useRouteContext();
  const isNew = id === "new";
  const query = useQuery({ queryKey: standingOrderKeys.detail(id), queryFn: () => getStandingOrder(id), enabled: !isNew });
  const canWrite = hasModule(session, "tms_orders_write");
  return (
    <div className="wl-page" data-screen-label="Back-office Standing Order">
      {isNew ? (
        <StandingOrderCard key="new" detail={null} canWrite={canWrite} />
      ) : query.data ? (
        <StandingOrderCard key={query.data.id} detail={query.data} canWrite={canWrite} />
      ) : (
        <Skeleton height="320px" />
      )}
    </div>
  );
}
